import { Component } from "react";
import Loader from "app/pages/.shared/Loader";
import "./loading-placeholder.scss";
import { messagePropType } from "app/utils/propTypes";

class LoadingPlaceholder extends Component {
	render() {
		const { message } = this.props;

		return (
			<div className="loading-placeholder">
				{message && <p className="loading-placeholder__message">{message}</p>}
				<Loader />
			</div>
		);
	}
}

LoadingPlaceholder.propTypes = {
	message: messagePropType,
};

export default LoadingPlaceholder;
